const RESTAURANTS = [
  {
    name: 'Wild Thyme Gourmet',
    description: 'A beloved Highlands institution known for creative, locally inspired cuisine. The outdoor patio seating area is a welcoming space for guests with dogs, offering a relaxed and upscale dining experience.',
    icon: 'ri-restaurant-2-line',
  },
  {
    name: 'The Ugly Dog Pub',
    description: 'A casual, convivial pub in the heart of Highlands with a name that says it all. The outdoor seating is dog-friendly and the atmosphere is lively — a great spot for a relaxed lunch or evening drink.',
    icon: 'ri-goblet-line',
  },
  {
    name: 'Four65 Woodfire Bistro + Bar',
    description: 'A stylish, contemporary restaurant featuring woodfire-inspired dishes and a curated bar program. Outdoor patio seating is available for guests with well-behaved dogs in a refined setting.',
    icon: 'ri-fire-line',
  },
  {
    name: 'The Log Cabin Restaurant',
    description: 'A classic Highlands dining experience in a warm, rustic setting. The outdoor area is suitable for guests traveling with dogs, and the menu leans into traditional mountain flavors done well.',
    icon: 'ri-home-5-line',
  },
  {
    name: 'Mountain Fresh Grocery',
    description: 'A local staple for fresh provisions, prepared foods, and picnic essentials. The outdoor area near the entrance is relaxed and dog-welcoming — ideal for a quick stop before heading out to the trails.',
    icon: 'ri-shopping-basket-line',
  },
  {
    name: 'Blue Bike Café',
    description: 'A charming neighborhood café with a warm, unhurried atmosphere. Outdoor seating makes it an easy choice for guests looking for a comfortable morning coffee or afternoon bite with their dog close by.',
    icon: 'ri-cup-line',
  },
];

export default function RestaurantsSection() {
  return (
    <section className="bg-[#FAFAF8] py-24 px-6 lg:px-14">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-14">
          <p className="text-[#C9A96E] text-xs tracking-[0.3em] uppercase font-jost mb-4">/ Dine Out Together</p>
          <h2 className="font-cormorant text-5xl text-[#1A1A18] font-light">
            Dog-Friendly<br /><em className="italic">Restaurants in Highlands NC</em>
          </h2>
          <p className="text-[#5C5850] font-jost text-sm mt-5 max-w-xl mx-auto leading-relaxed">
            Several of Highlands' best restaurants and cafés offer outdoor seating where well-behaved dogs are welcome. It is always a good idea to confirm with each restaurant before your visit, as policies may change seasonally.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {RESTAURANTS.map((r) => (
            <article key={r.name} className="bg-white rounded-2xl p-7 flex flex-col">
              <div className="flex items-center gap-4 mb-4">
                <div className="w-11 h-11 flex items-center justify-center rounded-full bg-[#EDE8E0] shrink-0">
                  <i className={`${r.icon} text-[#2D4A3E] text-xl`} />
                </div>
                <h3 className="font-cormorant text-xl text-[#1A1A18] font-medium leading-snug">{r.name}</h3>
              </div>
              <p className="text-[#5C5850] font-jost text-sm leading-relaxed flex-1">{r.description}</p>
              <div className="mt-5 flex items-center gap-2">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-checkbox-circle-line text-[#6B8C7D] text-sm" />
                </div>
                <span className="text-[#6B8C7D] text-xs font-jost">Outdoor seating available</span>
              </div>
            </article>
          ))}
        </div>

        <p className="text-center text-[#9C9890] text-xs font-jost mt-8 max-w-2xl mx-auto leading-relaxed">
          Many restaurants in Highlands offer outdoor seating where dogs are welcome, but policies may vary, so it&apos;s always a good idea to confirm ahead of time.
        </p>
      </div>
    </section>
  );
}
